
import "../../Style/About.scss";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";


function Aboutus() {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".Line", {
      width: 0,
    });
    gsap.to(".Line", {
      scrollTrigger: {
        trigger: ".Line",
      },
      width: "100%",
      duration: 2,
    });
    gsap.from(".h-8", {
      width: 0,
    });
    gsap.to(".Line", {
      scrollTrigger: {
        trigger: ".About-Section-2",
      },
      width: "100%",
      duration: 2,
    });
  });
  return (
    <div className="About-Container">
      <section className="About-Section-1" id="risjadsonland">
        <div className="Title-Section-1">
          <img className="logo-about" src={"https://res.cloudinary.com/doy2qixs5/image/upload/v1745494294/rbn/projects/logo/risjadson-land-logo.png"} />
          <div className="Line-Box">
            <span className="Line" />
          </div>
        </div>
        <div className="Content-Section">
          {/* <img src={'https://res.cloudinary.com/doy2qixs5/image/upload/v1746350636/rbn/about/pos-pengumben-indonesia_bgbxva.jpg'} /> */}
          <p>
            PT Risjadson Land was established in 1992 by Risjadson Group,
            focused in Real Estate and Construction. In 2022, Risjadson Land has
            expand their group portfolio with the adoption of Modern Method of
            Construction (MMoC), allowing them to create cost-efficient,
            sustainable, and precise delivery of construction work, especially
            in developing countries. Therefore, the company’s operations has
            expanded to Malaysia, Philippines, and Australia.
          </p>
        </div>
      </section>
      <section className="About-Section-2" id="risjadcon">
        <div className="Title-Section-2">
          <div className="Text-Container">
            <div className="Title">
              <img className="logo-about" src={"https://res.cloudinary.com/doy2qixs5/image/upload/v1746703753/rbn/logo/RCON-logo_ayiyi6.png"} />
              <div className="Line-Box">
                <span className="Line h-8" />
              </div>
            </div>
          </div>
        </div>
        <div className="Content-Section">
          {/* <img src={image2} /> */}
          <p>
            RCON (PT. Risjadson Bhumi Nusantara) is a company subsidiary of PT Risjadson Land. The
            company is in an expansion drive through the manufacturing of
            modular housing to overcome weakness in the traditional construction
            method. RCON has been undertaking high level of projects, showcasing
            dedication to building landmark national and international projects.
          </p>
        </div>
      </section>
      <section className="About-Section-2" id="risjadsonbt">
        <div className="Title-Section-2">
          <div className="Text-Container">
            <div className="Title">
              <img className="logo-about" src={"https://res.cloudinary.com/doy2qixs5/image/upload/v1746703744/rbn/logo/ribt-logo_oocrpt.png"}/>
              <div className="Line-Box">
                <span className="Line h-8" />
              </div>
            </div>
          </div>
        </div>
        <div className="Content-Section">
          <p>
            RiBT is a manufacturing company specializes in producing ferrous and
            non-ferrous metal products using the Industrialized Building System
            (IBS), contributing to advancements in the construction industry.
            The company is also the holder of proprietary intellectual property
            of ModForm. RiBT focuses on modular building, where components are
            manufactured and assembled in a controlled factory setting before
            being transported and installed on-site. The company has completed
            various project with diverse designs and purposes, emphasizing
            innovation and efficiency.
          </p>
        </div>
      </section>
      {/* <section className="About-Section-3" id="ourleader">
        <Accordion>
          <Card>
            <Card.Header id="Sec-3">
              <p>Our Leaders’ Past Involvement</p>
              <CustomToggle eventKey="0">+</CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <h3>Our leader's notable involvement throughout the years</h3>
                <div className="Accordion-content">
                  {Data &&
                    Data.map((props) => {
                      return (
                        <Card style={{ width: "25rem" }} key={props.id}>
                          <Card.Img
                            variant="top"
                            src={`images/About/${props.image}`}
                          />
                          <Card.Body>
                            <Card.Title>{props.title}</Card.Title>
                            <Card.Text>{props.desc}</Card.Text>
                          </Card.Body>
                        </Card>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </section> */}
    </div>
  );
}

export default Aboutus;
